import React, { useContext, useEffect, useState } from 'react'
import { IoMdRefresh, IoMdSearch } from 'react-icons/io'
import { SkyButton } from '../../Components/Buttons'
import AddMoney from './Popup/AddMoney'
import { GET_FLEET_TRANSACTIONS } from '../../Services/cabapi/fleetggl'
import { useLazyQuery } from '@apollo/client'
import moment from 'moment'
import { MyContext } from '../../utils/context/TempAuth'
import DatePicker from '../../Components/Input/DatePicker'
import { FaSort } from 'react-icons/fa' // Sorting icon
import Spinner from '../../Components/Spinner'
// <!--
// src="https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/vj0CPrA4kvr5lBM7.js"
// --
// >
const Transaction = () => {
  const { userData } = useContext(MyContext)
  const [warning, setWarning] = useState(false)
  const [addMoney, setAddMoney] = useState(false)
  const [accountBalance, setAccountBalance] = useState('Loading...')
  const [getFleetTransactions, { data, loading, refetch }] = useLazyQuery(
    GET_FLEET_TRANSACTIONS,
    {
      fetchPolicy: 'network-only', // Ensures that the query always fetches data from the server
    }
  )
  const [inputData, setInputData] = useState({
    fromDate: null,
    toDate: null,
    customerStatus: '',
  })

  const [transactions, setTransactions] = useState([]) // State to hold the fetched transactions
  const [sortConfig, setSortConfig] = useState({
    key: '', // Which column to sort by
    direction: 'asc', // Sort direction
  })

  // Fetching transaction data
  const getData = () => {
    getFleetTransactions({
      variables: {
        fleetOwnerId: userData?.fleetId,
      },
    })
      .then((res) => {
        setTransactions(res.data.getTransactionsByFleetOwnerId)
        setAccountBalance(res?.data?.getTransactionsByFleetOwnerId[0].balance)
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  useEffect(() => {
    getData()
  }, [])

  // Handle sorting
  const handleSort = (column) => {
    let direction = 'asc'
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc'
    }

    // Sort transactions when the user clicks on a column header
    const sortedTransactions = [...transactions].sort((a, b) => {
      if (!column) return 0

      const aValue = a[column]
      const bValue = b[column]

      // Handle ascending and descending
      if (direction === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
      }
    })

    // Set sorted transactions and update the sort config
    setTransactions(sortedTransactions)
    setSortConfig({ key: column, direction })
  }

  return (
    <div className="w-full h-full bg-white p-4 shadow rounded-md text-start">
      <div className="w-full flex text-start sm:flex-row sm:justify-between sm:items-start gap-4 sm:gap-0">
        <div className="text-stone-500 text-xl font-bold mb-4">
          Fleet Owner Transaction
        </div>
      </div>
      <div>
        <div className="flex flex-col md:flex md:flex-row gap-10">
          <div className="text-stone-500 text-md font-bold mb-2">
            Wallet Balance
            <div className="text-stone-500">&#8377; {accountBalance}</div>
          </div>
          <div className="mt-3">
            <SkyButton
              label={'Add Money'}
              onClick={() => {
                setAddMoney(true)
              }}
            />
          </div>
        </div>
        <hr />
      </div>
      <div>
        <div className="mt-5 flex flex-col sm:flex-row gap-4 sm:justify-between sm:items-end">
          <div className="w-full flex-grow text-start md:flex md:flex-row gap-3">
            {/* <DatePicker
              labelValue={'From Date'}
              onChange={(text) => {
                handleChange('fromDate', text)
              }}
              selected={inputData?.fromDate}
              name={'fromDate'}
              required
              title={'this field is required'}
            />
            <DatePicker
              labelValue={'To Date'}
              onChange={(text) => {
                handleChange('toDate', text)
              }}
              selected={inputData.toDate}
              name={'toDate'}
              required
              title={'this field is required'}
            />
            {warning ? (
              <span className="text-red-500 ">
                *Unable to retrieve more than 10 days data.
              </span>
            ) : (
              ''
            )} */}
          </div>
          <div className="flex sm:flex-row gap-2 sm:gap-4 mt-4 sm:mt-0">
            {/* <button className="bg-sky-500 px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80">
              <IoMdSearch size={20} />
              Search
            </button> */}
            <button
              onClick={() => getData()}
              className="bg-sky-500 px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80"
            >
              <IoMdRefresh size={20} />
              Refresh
            </button>
          </div>
        </div>
      </div>
      <div className="mt-4 w-full overflow-scroll h-[70vh]">
        {loading ? (
          <Spinner />
        ) : (
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-collapse border border-gray-300">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
              <tr>
                {[
                  { label: 'Transaction Id', key: 'bookingId' },
                  { label: 'Description', key: 'description' },
                  { label: 'Amount', key: 'amount' },
                  { label: 'Transaction Status', key: 'status' },
                  { label: 'Balance', key: 'balance' },
                  { label: 'Created At', key: 'created_at' },
                ].map((column, idx) => (
                  <th
                    key={idx}
                    scope="col"
                    className="px-2 py-3 border border-#cedbe2-800 cursor-pointer"
                    onClick={() => handleSort(column.key)}
                  >
                    <div className="flex items-center">
                      {column.label}
                      <FaSort size={14} className="ml-2" />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className=" w-full border border-#cedbe2-800">
              {transactions?.map((items, index) => (
                <tr key={index}>
                  <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                    {items?.bookingId ?? items?.transactionId}
                  </td>
                  <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                    {items?.description}
                  </td>
                  <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                    {items?.amount}
                  </td>
                  <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                    {items?.status}
                  </td>
                  <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                    {items?.balance}
                  </td>
                  <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                    {moment(items?.created_at).format('lll')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {addMoney && <AddMoney onClose={setAddMoney} refetch={getData} />}
    </div>
  )
}

export default Transaction
